define([
	'internal_util/Util',
	'canvas/LoadingCanvas',
	'lib/jquery'
], function (
	Util,
	LoadingCanvas,
	jQuery
) {
	'use strict';

	/**
	 * Abstract UIView class
	 */
	return function () {
		var _loadingCanvas = new LoadingCanvas(),
			_loadingOverlay = jQuery("<div id='skIdS_loading-shadow'></div>");

		_loadingOverlay.append(_loadingCanvas.get());


		// public methods

		this.get = function () {
			throw new Error('not implemented');
		};

		this.update = function () {
			throw new Error('not implemented');
		};

		this.setLoadingText = function (loadingText) {
			if (!Util.isValidString(loadingText)) {
				return;
			}

			if (_loadingOverlay.children().length === 2) {
				_loadingOverlay.children().first().remove();
			}

			_loadingOverlay.prepend('<span>' + loadingText + '<span>');
		};

		this.showLoadingIndicator = function () {
			var $view = jQuery(this.get());

			if ($view.children().last()[0] !== _loadingOverlay[0]) {
				$view.append(_loadingOverlay);
			}

			_loadingCanvas.enableAnimation();
		};

		this.hideLoadingIndicator = function () {
			var $view = jQuery(this.get());

			$view.children().each(function () {
				if (this === _loadingOverlay[0]) {
					jQuery(this).detach();

					return false;
				}
			});

			_loadingCanvas.disableAnimation();
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/UIView.js
// module id = 22
// module chunks = 1